import { useState } from 'react';
import { InitializeStep } from './steps/InitializeStep/InitializeStep';
import { SuccessStep } from './steps/SuccessStep/SuccessStep';

type Step = 'initialize' | 'success';

export const ForgotUsernameSteps = () => {
  const [currentStep, setCurrentStep] = useState<Step>('initialize');

  const steps = {
    initialize: <InitializeStep goToNextStep={() => setCurrentStep('success')} />,
    success: <SuccessStep />,
  };

  const currentStepComponent = steps[currentStep];

  return <div>{currentStepComponent}</div>;
};
